// Merge in the ItemRecord for any items that changed
const mergeChangedItemDates = (state, newItemDates, prevItemDates) => {
  return state.withMutations(s => {
    newItemDates.forEach((newDates, id) => {
      if (newDates !== prevItemDates.get(id)) {
        s.update(id, d => d.merge(newDates));
      }
    });
  });
};

export default mergeChangedItemDates;
